import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { ReactComponent as EpikLogoSvg } from '../Res/granite-logo.svg';
import RangeCheck from '../Res/RangeCheck.png';
import { Button, Col, Navbar, FormGroup, Label, Input, Row, Tooltip } from 'reactstrap';
import './BoxCheck.css';
import {
  getSpeedTestInformation,
  addUnAuthNote,
  getUpDownSpeedInformation,
} from '../actions/EpikBoxes';
import Spinner from '../components/Spinner/Spinner';
import { toast } from 'react-toastify';
const navStyle = {
  boxShadow: '#17a2b8 -1px -1px 7px',
  position: 'fixed',
  top: '0',
  // overflow: 'hidden',
  width: '100%',
  zIndex: 99999,
  display: 'flex',
  justifyContent: 'space-between',
};
class BoxCheck extends Component {
  constructor(props) {
    super(props);
    this.state = {
      serialNumber: '',
      loading: false,
      boxId: '',
      speedBox: '',
      upDownSpeed: '',
      voiceTipOpen: false,
      dataTipOpen: false,
    };
  }
  onCheckDetail = async () => {
    const { serialNumber } = this.state;
    const { addUnAuthNote, getSpeedTestInformation } = this.props;
    if (serialNumber.length > 0) {
      this.setState({ loading: true });
      const speedInfo = await getSpeedTestInformation(serialNumber);
      this.setState({ loading: false, speedBox: speedInfo.speedTestInfo }, async () => {
        if (speedInfo.speedTestInfo) {
          await addUnAuthNote(speedInfo.speedTestInfo.boxId, speedInfo.speedTestInfo);
        }
      });
    } else {
      toast.error('Please enter serial number');
    }
  };

  onVoiceDetail = async type => {
    const { serialNumber } = this.state;
    const { getUpDownSpeedInformation } = this.props;
    if (serialNumber.length > 0) {
      this.setState({ loading: true });
      const upDownSpeedInfo = await getUpDownSpeedInformation(serialNumber, type);
      this.setState({ loading: false, upDownSpeed: upDownSpeedInfo.speedTestInfo });
    } else {
      toast.error('Please enter serial number');
    }
  };

  onDataDetail = async type => {
    const { serialNumber } = this.state;
    const { getUpDownSpeedInformation } = this.props;
    if (serialNumber.length > 0) {
      this.setState({ loading: true });
      const upDownSpeedInfo = await getUpDownSpeedInformation(serialNumber, type);
      this.setState({ loading: false, upDownSpeed: upDownSpeedInfo.speedTestInfo });
    } else {
      toast.error('Please enter serial number');
    }
  };

  onFormFieldChange = e => {
    const { value, name } = e.currentTarget;
    this.setState({ serialNumber: value });
  };
  voiceTooltip = () => {
    const { voiceTipOpen } = this.state;
    this.setState({ voiceTipOpen: !voiceTipOpen });
  };
  dataTooltip = () => {
    const { dataTipOpen } = this.state;
    this.setState({ dataTipOpen: !dataTipOpen });
  };
  render() {
    const { loading, speedBox, upDownSpeed, voiceTipOpen, dataTipOpen } = this.state;
    return (
      <>
        <Navbar style={navStyle} dark color="light" expand="lg">
          <Link
            to="/"
            className="navbar-brand"
            style={{ padding: '.5rem 1rem', borderRight: '2px solid rgba(138, 138, 138, 0.2)' }}
          >
            <EpikLogoSvg width={120} height={60} />
          </Link>
          <h1 className="top-text">Edge Device Check</h1>
        </Navbar>
        <div className="box-check-container">
          <div className="inner-container">
            <Row className="form-container">
              <Col lg={4} md={4} sm={12}>
                <FormGroup>
                  <Label for="model" sm={8}>
                    Serial Number:
                  </Label>
                  <Col sm={12}>
                    <Input
                      required
                      placeholder="Please specify"
                      type="text"
                      name="serialNumber"
                      value={this.state.serialNumber}
                      onChange={this.onFormFieldChange}
                    />
                  </Col>
                </FormGroup>
              </Col>
              <Col lg={8} md={4} sm={12} className="top-button-container">
                <Button color="primary" onClick={this.onCheckDetail}>
                  Look Up Serial Number
                </Button>
              </Col>
            </Row>
            <Row className="buttons-container">
              <Col
                lg={3}
                md={6}
                sm={12}
                style={{ justifyContent: 'space-around', display: 'flex' }}
              >
                <Tooltip
                  placement={'top'}
                  isOpen={voiceTipOpen}
                  target={`voice-check-tip`}
                  toggle={this.voiceTooltip}
                >
                  UDP check capped at 1.05mb to avoid circuit saturation.
                </Tooltip>
                <Button
                  id="voice-check-tip"
                  color="primary"
                  onClick={() => this.onVoiceDetail('voice')}
                >
                  Voice Speed Check
                </Button>
                <Tooltip
                  placement={'top'}
                  isOpen={dataTipOpen}
                  target={`data-check-tip`}
                  toggle={this.dataTooltip}
                >
                  TCP check with no speed/data limits.
                </Tooltip>
                <Button
                  id="data-check-tip"
                  color="primary"
                  onClick={() => this.onDataDetail('data')}
                >
                  Data Speed Check
                </Button>
              </Col>
            </Row>
          </div>
          <div className="table-container">
            {loading && <Spinner text />}
            <Row className="list-container">
              <Col lg={3} md={6} sm={12}>
                <h1 className="heading-list">4G</h1>
                {speedBox && (
                  <div>
                    <h1>imei = {speedBox.imei.length > 0 && speedBox.imei[0]}</h1>
                    <h1>simlD = {speedBox.imsi.length > 0 && speedBox.imsi[0]}</h1>
                    <h1>Phone Number = {speedBox.phone}</h1>
                    <h1>Signal Info:</h1>
                    <div className="bottom-inner">
                      <div style={{ marginRight: '30px' }}>
                        <h1>type: {speedBox.signalInfo.type}</h1>
                        <h1>rssi: {speedBox.signalInfo.rssi}</h1>
                        <h1>ecio: {speedBox.signalInfo.ecio}</h1>
                        <h1>io: {speedBox.signalInfo.io}</h1>
                      </div>
                      <div>
                        <h1>rsrq: {speedBox.signalInfo.rsrq}</h1>
                        <h1>snr: {speedBox.signalInfo.snr}</h1>
                        <h1>rsrp: {speedBox.signalInfo.rsrp}</h1>
                      </div>
                    </div>
                  </div>
                )}
              </Col>

              <Col lg={3} md={6} sm={12}>
                <h1 className="heading-list">Latency</h1>
                {upDownSpeed && <h1>{upDownSpeed.latency}</h1>}
              </Col>

              <Col lg={3} md={6} sm={12}>
                <h1 className="heading-list">Jitter</h1>
                {upDownSpeed && <h1>{upDownSpeed.jitter}</h1>}
              </Col>

              <Col lg={3} md={6} sm={12}>
                <h1 className="heading-list">Speed Test</h1>
                {upDownSpeed && (
                  <>
                    <h1>Upload Speed : {upDownSpeed.uploadSpeed}</h1>
                    <h1>Download Speed : {upDownSpeed.downloadSpeed}</h1>
                  </>
                )}
              </Col>
            </Row>
          </div>
          <div className="bottom-container">
            <Row>
              <Col
                lg={6}
                md={6}
                sm={12}
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
              >
                {/* <Button color="primary" onClick={this.onDataDetail}>
                  Check Whitelist
                </Button> */}
              </Col>
              <Col lg={6} md={6} sm={12}>
                <img style={{ width: '100%', height: '100%' }} alt="RangeTable" src={RangeCheck} />
              </Col>
            </Row>
          </div>
        </div>
      </>
    );
  }
}
const mapDispatchToProps = dispatch => ({
  getSpeedTestInformation: serialNumber => dispatch(getSpeedTestInformation(serialNumber)),
  getUpDownSpeedInformation: (serialNumber, type) =>
    dispatch(getUpDownSpeedInformation(serialNumber, type)),

  addUnAuthNote: (id, note) => dispatch(addUnAuthNote(id, note)),
});

export default connect(
  null,
  mapDispatchToProps,
)(BoxCheck);
